import { useSelector } from "react-redux"
import { State } from "../../../../reducers"
import { getLogoEmpresa } from "../../../../actions/operaciones/operaciones.actions"
import { useEffect } from "react"
import { Pagination } from "../../../../components/Pagination"
import useComprobanteLiquidacion from "../../../../actions/comprobante-liquidacion"
import { unirChipsJoin, unirChipsReturnFirst } from "../../../../utils/strings.utils"

export default function DTEComprobanteLiquidacion (){
    const {formCliente, productos, response_QRcode, view, documentosAsociados,mostrarDetalle, tableProductos} = useSelector((state: State) => state.comprobanteLiquidacion )
    const {datosUUID} = useSelector((state: State) => state.facturacion)
    const {datosEmisor, tipoDocumento, actividadesEconomicas, municipios, departamentos, tipoDocumentosEmision} = useSelector((state: State) => state.catalogos)
    const {datos} = useSelector((state: State) => state.userLogin)
    const sucursal = formCliente?.datosSucursal?.find((suc: any) => suc?.idsucursal === formCliente.sucursal)?.nombre
    const documento = formCliente?.datosSucursal?.find((suc: any) => suc?.idsucursal === formCliente.sucursal)?.Documento?.find((doc: any) => doc.idsucursaldocumento === formCliente.serie)
    const serie = `${documento?.serie}-${documento?.numeroactual}`
    const {button_mostrarDetalle, setTableProductos, calculosDocumentos} = useComprobanteLiquidacion()
    const datosReceptor = useSelector((state: State) => state.documentos.datosReceptor.form)

    
    
    useEffect(() => {
        setTableProductos(documentosAsociados)
    }, [documentosAsociados])


    return (
        <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ec5-0b1e6fa6' className='w-layout-layout bill-section wf-layout-layout w-100' >
        <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell w-100' >
        <div className="card">
            <div className="dte-title">
                <label>{view === 'Previsualizacion' ? 'PREVISUALIZACIÓN DE ' : '' }DOCUMENTO TRIBUTARIO ELECTRÓNICO</label>
                <label>COMPROBANTE DE LIQUIDACIÓN</label>
            </div>
            <div className="separador" />
            <div className='dt-card-grid-2c-1r' style={{alignItems: 'center'}}>
                <div className='dt-card-2c-1r-no-border' style={{textAlign: 'center'}}>
                    <img alt="Logo" src={getLogoEmpresa()} className='logo-itprofis'/>
                </div>
                <div className='dt-card-2c-1r' style={{padding:"3% 0"}}>
                    <table className="dte-table">
                        <tr>
                            <td>Documento Tributario Electrónico Versión:</td>
                            <td>{datosUUID?.Version}</td>
                        </tr>
                        <tr>
                            <td>Código de Generación:</td>
                            <td>{datosUUID?.CodigoGeneracion}</td>
                        </tr>
                        <tr>
                            <td>Sucursal:</td>
                            <td>{sucursal}</td>
                        </tr>
                        <tr>
                            <td>Serie:</td>
                            <td>{serie}</td>
                        </tr>
                        <tr>
                            <td>Moneda:</td>
                            <td>USD - Dólar estadounidense</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div className='dt-card-grid-2c-1r'>
                {/* DATOS DEL RECEPTOR */}
                <div className='dt-card-2c-1r' style={{padding:"3% 0"}}>
                <div className='dt-center-content'>
                    <label className="dte-subsection-title">Receptor</label>
                    <table className="dte-table">
                        <tr><td>Nombre:</td><td>{formCliente?.nombre}</td></tr>
                        <tr><td>NIT:</td><td>{formCliente?.noDocumento}</td></tr>
                        <tr><td>NRC:</td><td>{formCliente?.nrc}</td></tr>
                        <tr><td>Actividad económica:</td><td>{actividadesEconomicas.find((actividad) => actividad.codigo === formCliente?.actividad)?.valor}</td></tr>
                        <tr><td>Teléfono celular:</td><td>{formCliente?.telefono}</td></tr>
                        <tr><td>Correo electrónico:</td><td>{unirChipsReturnFirst(formCliente?.chipsEmail, formCliente?.email)}</td></tr>
                        <tr><td>Dirección:</td><td>{formCliente?.direccion}</td></tr>
                        <tr><td>Departamento:</td><td>{departamentos.find((departamento) => departamento.codigo === formCliente?.departamento)?.valor?.toUpperCase() }</td></tr>
                        <tr><td>Municipio:</td><td>{municipios.find((municipio) => municipio.codigo === formCliente?.municipio)?.valor?.toUpperCase() }</td></tr>
                        <tr><td>Envío de documento por correo electrónico a:</td><td>{unirChipsJoin(formCliente?.chipsEmail, formCliente?.email)}</td></tr>
                    </table>
                </div>
                </div>
                {/* DATOS DEL EMISOR */}
                <div className='dt-card-2c-1r' style={{padding:"3% 0"}}>
                    <label className="dte-subsection-title">Emisor</label>
                    <table className="dte-table">
                        <tr><td>Tipo de persona:</td><td>{datosEmisor?.desTipoEmpresa ?? ''}</td></tr>
                        <tr><td>Tipo de contribuyente:</td><td>{datosEmisor?.desContribuyente ?? ''}</td></tr>
                        <tr><td>Nombre del cliente:</td><td>{datosEmisor?.nombre}</td></tr>
                        <tr><td>Dirección:</td><td>{datosEmisor?.complemento}</td></tr>
                        <tr><td>Departamento:</td><td>{datosEmisor?.departamentonombre}</td></tr>
                        <tr><td>Municipio:</td><td>{datosEmisor?.municipionombre}</td></tr>
                        <tr><td>Giro:</td><td>{datosEmisor?.descactividad}</td></tr>
                        <tr><td>NIT:</td><td>{datosEmisor?.nit}</td></tr>
                        <tr><td>NRC:</td><td>{datosEmisor?.nrc}</td></tr>
                        <tr><td>Teléfono celular:</td><td>{datosEmisor?.telefono}</td></tr>
                        <tr><td>Correo electrónico:</td><td>{datosEmisor?.correo}</td></tr>
                    </table>
                </div>
            </div>
            <label className="dte-subsection-title">Documentos asociados</label>
            <div className="tab-plane" style={{marginTop: "25px"}}>
                <div className="table-facturacion-resp">
                    <table className="table-main-responsive responsive-table-main td-left table-pointer">
                        <thead>
                            <tr>
                                <td>Tipo de DTE</td>
                                <td>Numero de documento</td>
                                <td>Fecha de generación</td>
                                <td>Venta gravada</td>
                                <td>Venta no sujeta</td>
                                <td>Venta exenta</td>
                            </tr>
                        </thead>
                        <tbody>
                            {tableProductos?.map((documento, index) => {
                                let fechaSplit = documento?.fechaEmision?.split(' ')[0]?.split('-')
                                let fecha = `${fechaSplit[2]}-${fechaSplit[1]}-${fechaSplit[0]}`
                                let gravada = 0
                                let noSujeta = 0
                                let exenta = 0
                                if(documento?.tipoGeneracion === 2){
                                    switch(documento?.tipoDocumento){
                                        case '01':
                                            gravada = parseFloat(documento?.resumen?.totalGravada || '0')/1.13
                                            break;
                                        default:
                                            gravada = parseFloat(documento?.resumen?.totalGravada || '0')
                                            break;
                                    }
                                } else {
                                    noSujeta = parseFloat(documento?.resumen?.noSujeto || '0')
                                    exenta = parseFloat(documento?.resumen?.exentas || '0')
                                    gravada =  
                                        parseFloat(documento?.tipoDocumento === '11' ? documento?.resumen?.exportaciones : documento?.resumen?.gravadas)
                                }

                                return(
                                <tr key={index}>
                                    <td data-label="Tipo de DTE">{tipoDocumentosEmision?.find((tipo) => tipo.codigodocumento === documento?.tipoDocumento)?.nombre}</td>
                                    <td data-label="Numero de documento">{documento?.numeroControl}</td>
                                    <td data-label="Fecha de generación">{fecha}</td>
                                    <td data-label="Venta gravada">{gravada?.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                    <td data-label="Venta no sujeta">{(documento?.resumen?.totalNoSuj || noSujeta)?.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                    <td data-label="Venta exenta">{(documento?.resumen?.totalExenta || exenta)?.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                            )})}
                        </tbody>
                    </table>
                </div>
                    <Pagination data = {documentosAsociados} state = {(items: Array<any>) => setTableProductos(items)} items = {10}/>
                    <div className="cf-calculos-producto">
                        <table>
                            <tbody>
                                <tr className="cf-subtotal">
                                    <td>Total de operaciones no sujetas</td>
                                    <td>{calculosDocumentos().test_totalOperacionesNoSujetas.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                                <tr className="cf-subtotal">
                                    <td>total de operaciones exentas</td>
                                    <td>{calculosDocumentos().test_totalOperacionesExentas.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                                <tr className="cf-subtotal">
                                    <td>Total de operaciones gravadas</td>
                                    <td>{calculosDocumentos().test_totalOperacionesGravadas.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                                <tr className="cf-subtotal">
                                    <td>Total de operaciones de exportación</td>
                                    <td>{calculosDocumentos().test_totalOperacionesExportacion.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                                <tr className="cf-subtotal">
                                    <td>Monto total de la operación</td>
                                    <td>{calculosDocumentos().test_montoTotalOperacion.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                                <tr className="cf-subtotal">
                                    <td>Impuesto al Valor Agregado 13%</td>
                                    <td>{calculosDocumentos().test_iva.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                                <tr className="cf-descuento">
                                    <td>IVA percibido</td>
                                    <td>{calculosDocumentos().test_ivaPercibido.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                                <tr className="cf-total">
                                    <td>Total</td>
                                    <td>{calculosDocumentos().test_total.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
            </div>
            
            <div className='dt-card w-100 text-center' style={{padding: 0}}>
            {response_QRcode ? <div className='dt-card-grid-3c'>
              {response_QRcode && <div>
                <img src={response_QRcode} alt='qr' className='dt-img-qr'/>
              </div>}
              <div className='dt-card-2c-responsive'>
                <div className='detail'>
                  <label>Responsable por parte del Emisor:</label>
                  <label>{datos?.name}</label>
                </div>
                <div className='detail'>
                  <label>Responsable por parte del Receptor:</label>
                <label>{datosReceptor.nombre ? datosReceptor.nombre : formCliente?.nombre}</label>
                </div>
              </div>
              <div className='dt-card-2c-responsive'>
                <div className='detail'>
                  <label>{datos?.tipo_documento || 'N° de Documento'}:</label>
                  <label>{datos?.documento}</label>
                </div>
                <div className='detail'>
                  <label>{`${datosReceptor.nombreTipoDocumento ? `${datosReceptor.nombreTipoDocumento}` : tipoDocumento.find((doc) => doc.codigo === formCliente.tipoDocumento)?.valor}:`}</label>
                  <label>{datosReceptor.nombreTipoDocumento ? datosReceptor.numId : formCliente?.noDocumento}</label>
                </div>
              </div>
            </div> :
            <div className={'dt-card-grid-2c'}>
                <div className='detail'>
                  <label>Responsable por parte del Emisor:</label>
                  <label>{datos?.name}</label>
                </div>
                <div className='detail'>
                  <label>{datos?.tipo_documento || 'N° de Documento'}:</label>
                  <label>{datos?.documento}</label>
                </div>
                <div className='detail'>
                  <label>Responsable por parte del Receptor:</label>
                <label>{datosReceptor.nombre ? datosReceptor.nombre : formCliente?.nombre}</label>
                </div>
                <div className='detail'>
                  <label>{`${datosReceptor.nombreTipoDocumento ? `${datosReceptor.nombreTipoDocumento}` : tipoDocumento.find((doc) => doc.codigo === formCliente.tipoDocumento)?.valor}:`}</label>
                  <label>{datosReceptor.nombreTipoDocumento ? datosReceptor.numId : formCliente?.noDocumento}</label>
                </div>
            </div> }
            </div>
        </div>
        </div>
        </div>
    )
}